import {
  FaEnvelope, FaPhone, FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub,
  FaYoutube, FaInstagram, FaWhatsapp, FaTelegram, FaReddit, FaPinterest,
  FaSnapchatGhost, FaTiktok, FaDiscord, FaMedium, FaQuora, FaStackOverflow,
  FaBehance, FaDribbble, FaFigma, FaSketch, FaWordpress, FaBlogger, FaTumblr
} from "react-icons/fa";

export const floatingIcons = [
  { icon: <FaEnvelope />, top: "10%", left: "5%", delay: "0s" },
  { icon: <FaPhone />, top: "50%", right: "5%", delay: "2s" },
  { icon: <FaFacebookF />, bottom: "16%", left: "30%", delay: "0s" },
  { icon: <FaTwitter />, top: "33%", right: "25%", delay: "1s" },
  { icon: <FaLinkedinIn />, bottom: "8%", right: "10%", delay: "0s" },
  { icon: <FaGithub />, top: "20%", left: "50%", delay: "0.5s" },
  { icon: <FaYoutube />, bottom: "20%", left: "10%", delay: "1.5s" },
  { icon: <FaInstagram />, top: "25%", right: "15%", delay: "0.8s" },
  { icon: <FaWhatsapp />, bottom: "30%", right: "20%", delay: "1.2s" },
  { icon: <FaTelegram />, top: "40%", left: "20%", delay: "0.6s" },
  { icon: <FaReddit />, bottom: "10%", left: "50%", delay: "2.5s" },
  { icon: <FaPinterest />, top: "60%", right: "5%", delay: "0.3s" },
  { icon: <FaSnapchatGhost />, top: "45%", left: "35%", delay: "1s" },
  { icon: <FaTiktok />, top: "15%", right: "40%", delay: "1.4s" },
  { icon: <FaDiscord />, bottom: "25%", left: "60%", delay: "1.8s" },
  { icon: <FaMedium />, top: "5%", left: "80%", delay: "2.2s" },
  { icon: <FaQuora />, top: "65%", right: "30%", delay: "1.6s" },
  { icon: <FaStackOverflow />, bottom: "18%", right: "25%", delay: "0.9s" },
  { icon: <FaBehance />, top: "70%", left: "10%", delay: "1.1s" },
  { icon: <FaDribbble />, top: "35%", right: "5%", delay: "2.3s" },
  { icon: <FaFigma />, bottom: "12%", right: "50%", delay: "1.7s" },
  { icon: <FaSketch />, top: "18%", left: "25%", delay: "0.4s" },
  { icon: <FaWordpress />, bottom: "5%", right: "5%", delay: "2.8s" },
  { icon: <FaBlogger />, top: "50%", left: "15%", delay: "1.3s" },
  { icon: <FaTumblr />, bottom: "40%", right: "40%", delay: "1.9s" },
];
